import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";

export const hitGtmFilterRoomsInBox = () => {
    hitGoogleTagManager({
        ...sharedParams,
        GAEventLabel: "pokoje_kafel"
    });
};

export const hitGtmFilterBudgetInBox = (isInstalmentFilter: boolean) => {
    hitGoogleTagManager({
        ...sharedParams,
        GAEventLabel: `budżet_kafel${isInstalmentFilter ? "_rata" : "_kwota"}`
    });
};

const sharedParams = {
    event: "GAEvent",
    GAEventCategory: "ui",
    GAEventAction: "filtry",
    GAEventNoInteraction: false
};

export const hitGtmPriceTransparencyBox = (action: "view" | "click", position: number) => {
    hitGoogleTagManager({event: "tile_transparency_price", event_action: action, event_label: position});
};
import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";

export const hitGtmFilterRoomsInBox = () => {
    hitGoogleTagManager({
        ...sharedParams,
        GAEventLabel: "pokoje_kafel"
    });
};

export const hitGtmFilterBudgetInBox = (isInstalmentFilter: boolean) => {
    hitGoogleTagManager({
        ...sharedParams,
        GAEventLabel: `budżet_kafel${isInstalmentFilter ? "_rata" : "_kwota"}`
    });
};

const sharedParams = {
    event: "GAEvent",
    GAEventCategory: "ui",
    GAEventAction: "filtry",
    GAEventNoInteraction: false
};

export const hitGtmPriceTransparencyBox = (action: "view" | "click", position: number) => {
    hitGoogleTagManager({event: "tile_transparency_price", event_action: action, event_label: position});
};
